import { render, staticRenderFns } from "./AddShopPhoto.vue?vue&type=template&id=25b3dc63&"
import script from "./AddShopPhoto.vue?vue&type=script&lang=js&"
export * from "./AddShopPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports